import { render, staticRenderFns } from "./SummaryView.vue?vue&type=template&id=b767292c&scoped=true"
import script from "./SummaryView.vue?vue&type=script&lang=js"
export * from "./SummaryView.vue?vue&type=script&lang=js"
import style0 from "./SummaryView.vue?vue&type=style&index=0&id=b767292c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b767292c",
  null
  
)

export default component.exports